import { Cloud, Clouds, Float } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { gsap } from 'gsap/gsap-core';
import { useEffect, useRef, useState } from 'react';
import { Group, Material, MeshBasicMaterial } from 'three';

import { findTransparentMaterials } from '0_canvas/CloudTransition/CloudTransition.utils';
import { publicAssets } from 'utils/gcs';

interface CloudOverlayProps {
  color?: string;
  opacity?: number;
  isRendered?: boolean;
}

const CloudOverlay = ({ color = 'white', opacity = 1 }: CloudOverlayProps) => {
  const {
    camera,
    viewport: { width, height },
  } = useThree();
  const cloudsRef = useRef<Group | null>(null);
  const [cloudMaterial, setCloudMaterial] = useState<Material | null>(null);

  useEffect(() => {
    if (!cloudsRef.current) {
      return;
    }

    cloudsRef.current.lookAt(camera.position);
    const cloudMaterials = findTransparentMaterials(cloudsRef.current);
    cloudMaterials.forEach(mat => {
      mat.opacity = 0;
    });
    setCloudMaterial(cloudMaterials?.[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!cloudMaterial) {
      return;
    }

    gsap.to(cloudMaterial, {
      opacity,
      duration: 2,
      ease: 'power2.out',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opacity]);

  const randomSpeed = () => Math.random() * (1.6 - 1.4) + 1.4;

  return (
    <>
      <Clouds
        ref={cloudsRef}
        material={MeshBasicMaterial}
        texture={publicAssets('/cloud.png')}
        visible={true}
      >
        <Float
          speed={randomSpeed()}
          rotationIntensity={1}
          floatIntensity={5}
          floatingRange={[-0.8, 0.8]}
        >
          <Cloud
            seed={8}
            scale={25}
            volume={5}
            color={color}
            opacity={opacity}
            segments={1}
            position={[width / 2.75, height / 2 + 55, 0]}
          />
        </Float>

        <Float
          speed={randomSpeed()}
          rotationIntensity={1}
          floatIntensity={5}
          floatingRange={[-0.8, 0.8]}
        >
          <Cloud
            seed={112}
            scale={20}
            volume={4}
            color={color}
            opacity={opacity}
            position={[width + (width > height ? -30 : 80), 15, 0]}
          />
        </Float>

        <Float
          speed={randomSpeed()}
          rotationIntensity={1}
          floatIntensity={5}
          floatingRange={[-0.8, 0.8]}
        >
          <Cloud
            seed={100}
            scale={20}
            volume={1}
            color={color}
            opacity={opacity}
            position={[-width / 2 - 85, 20, 0]}
            //position={[0, 0, 0]}
          />
        </Float>

        <Float
          speed={randomSpeed()}
          rotationIntensity={1}
          floatIntensity={5}
          floatingRange={[-0.8, 0.8]}
        >
          <Cloud
            seed={3}
            scale={15}
            volume={10}
            color={color}
            opacity={opacity}
            position={[-width / 2 + 10, -height / 2 - 50, 0]}
          />
        </Float>

        <Float
          speed={randomSpeed()}
          rotationIntensity={1}
          floatIntensity={5}
          floatingRange={[-0.8, 0.8]}
        >
          <Cloud
            seed={12}
            scale={15}
            volume={10}
            color={color}
            opacity={opacity}
            position={[width / 2 - 50, -height / 2 - 45, 0]}
          />
        </Float>
      </Clouds>
    </>
  );
};
export default CloudOverlay;
